import { render, staticRenderFns } from "./galleryAdmin.vue?vue&type=template&id=0228d790&"
import script from "./galleryAdmin.vue?vue&type=script&lang=js&"
export * from "./galleryAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports